// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3iLOK","inputWrap":"styles_inputWrap__kVcso","input":"styles_input__ZW4BX"};